import { EPLEDGE_PLEDGE_DETAILS } from "../interface/iEpledgePledge";
import { EPLEDGE_PLEDGE_ERROR } from "../interface/iEpledgePledge";
import { EPLEDGE_PLEDGE_HIDE_ERROR } from "../interface/iEpledgePledge";
import { EPLEDGE_PLEDGE_START_LOADER } from "../interface/iEpledgePledge";
import { EPLEDGE_PLEDGE_STOP_LOADER } from "../interface/iEpledgePledge";
const initState = {
    data: {},
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const EpledgePledgeReducer = (state = initState, action) => {
    switch (action.type) {
        case EPLEDGE_PLEDGE_DETAILS: {
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        }
        case EPLEDGE_PLEDGE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case EPLEDGE_PLEDGE_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case EPLEDGE_PLEDGE_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case EPLEDGE_PLEDGE_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default EpledgePledgeReducer;
